import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import { IMaskInput } from "react-imask";
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import {FaCheck} from "react-icons/fa";
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class ConsultoresEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            erroLoadRegistro: "",
            consultor_id: "",
            titulo_pagina: "",
            loading: false,
            nome: '',
            cpf: '',
            email: '',
            telefone: '',
            programa_id: "",
            programa_nome: "",
            estados: [],
            doencas: [],
        };
    }

    componentDidMount() {
        const id = this.props.router.params.id;
    
        if (id) {
            this.setState({
                consultor_id: id,
                titulo_pagina: 'Editando Consultor',
                loading: true,
                erroLoadRegistro: ''
            });

            api.get(`/consultores/${id}/`)
            .then(response => {
                const dados = response.data;
                let estadosSelecionados = [];
                if (Array.isArray(dados.estados_list)) {
                    estadosSelecionados = dados.estados_list.map(s => ({ value: s.uf, label: s.uf }));
                } else if (Array.isArray(dados.estados)) {
                    estadosSelecionados = dados.estados.map(uf => ({ value: uf, label: uf }));
                }

                const doencasSelecionadas = Array.isArray(dados.dados_doencas)
                    ? dados.dados_doencas.map(d => ({ value: d.id, label: d.nome }))
                    : [];

                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    cpf: dados.cpf,
                    email: dados.email,
                    telefone: dados.telefone,
                    programa_id: dados.programa_id,
                    programa_nome: dados.dados_programa.nome,
                    estados: estadosSelecionados,
                    doencas: doencasSelecionadas,
                    //remonta o select de patologias agora que o programa_id esta carregado
                    doencas_select_key: Date.now(),
                    loading: false
                });
            })
                .catch(error => {
                    let erro_msg = 'Erro ao carregar consultor, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                consultor_id: '',
                titulo_pagina: 'Adicionar Consultor',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            tipoHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.consultor_id) ? '/consultores/'+this.state.consultor_id+'/' : '/consultores/'
        const metodo = (this.state.consultor_id) ? 'put' : 'post'

        let payload = {
            nome: this.state.nome,
            programa_id: this.state.programa_id,
            estados: Array.isArray(this.state.estados) ? this.state.estados.map(s => s.value) : [],
            doenca_ids: Array.isArray(this.state.doencas) ? this.state.doencas.map(d => d.value) : []
        };

        if(this.state.cpf) {
            payload['cpf'] = this.state.cpf;
        }

        if(this.state.email) {
            payload['email'] = this.state.email;
        }

        if(this.state.telefone) {
            payload['telefone'] = this.state.telefone;
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.consultor_id) ? 'Consultor atualizado com sucesso' : 'Consultor cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.consultor_id){
                this.props.router.navigate("/consultores");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar consultor, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    carregarEstados = async (inputValue) => {
        const estadosBrasileiros = [
            { value: 'AC', label: 'Acre' },
            { value: 'AL', label: 'Alagoas' },
            { value: 'AM', label: 'Amazonas' },
            { value: 'AP', label: 'Amapá' },
            { value: 'BA', label: 'Bahia' },
            { value: 'CE', label: 'Ceará' },
            { value: 'DF', label: 'Distrito Federal' },
            { value: 'ES', label: 'Espírito Santo' },
            { value: 'GO', label: 'Goiás' },
            { value: 'MA', label: 'Maranhão' },
            { value: 'MT', label: 'Mato Grosso' },
            { value: 'MS', label: 'Mato Grosso do Sul' },
            { value: 'MG', label: 'Minas Gerais' },
            { value: 'PA', label: 'Pará' },
            { value: 'PB', label: 'Paraíba' },
            { value: 'PR', label: 'Paraná' },
            { value: 'PE', label: 'Pernambuco' },
            { value: 'PI', label: 'Piauí' },
            { value: 'RJ', label: 'Rio de Janeiro' },
            { value: 'RN', label: 'Rio Grande do Norte' },
            { value: 'RS', label: 'Rio Grande do Sul' },
            { value: 'RO', label: 'Rondônia' },
            { value: 'RR', label: 'Roraima' },
            { value: 'SC', label: 'Santa Catarina' },
            { value: 'SP', label: 'São Paulo' },
            { value: 'SE', label: 'Sergipe' },
            { value: 'TO', label: 'Tocantins' },
        ];

        const filtered = estadosBrasileiros.filter(estado =>
            estado.label.toLowerCase().includes((inputValue || '').toLowerCase()) ||
            estado.value.toLowerCase().includes((inputValue || '').toLowerCase())
        );

        return filtered;
    };

    carregarDoencas = async (inputValue) => {
        if (!this.state.programa_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/doencas/?programa_id=${this.state.programa_id}`);
            const opcoes = response.data.results.map(doenca => ({
                value: doenca.dados_doenca.id,
                label: doenca.dados_doenca.nome
            }));

            return opcoes.filter(opcao =>
                opcao.label.toLowerCase().includes((inputValue || '').toLowerCase())
            );
        } catch (error) {
            console.error('Erro ao carregar patologias:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    handleChange = (event, fieldName) => {
        if (fieldName == "programa_id") {
            //as patologias sao vinculadas ao programa, entao a selecao anterior e descartada
            this.setState(prevState => ({
                programa_id: event.value,
                programa_nome: event.label,
                doencas: prevState.programa_id === event.value ? prevState.doencas : [],
                doencas_select_key: Date.now()
            }));
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangeEstados = (selected) => {
        this.setState({ estados: selected || [] });
    };

    handleChangeDoencas = (selected) => {
        this.setState({ doencas: selected || [] });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosConsultor" id="tabs-consultor" className="aditus-tabs">
                    <Tab eventKey="dadosConsultor" title="Dados do Consultor"> 
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegistro}>
                                        <h4>Consultor</h4>
                                        <Row>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Nome <span>*</span></Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="nome" 
                                                        value={this.state.nome} 
                                                        required={true}
                                                        onChange={e => this.handleChange(e, 'nome')} 
                                                        placeholder="Nome"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>CPF</Form.Label>
                                                    <Form.Control
                                                        as={IMaskInput}
                                                        mask="000.000.000-00"
                                                        name="cpf"
                                                        value={this.state.cpf}
                                                        onChange={e => this.handleChange(e, 'cpf')} 
                                                        placeholder="CPF"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>E-mail</Form.Label>
                                                    <Form.Control 
                                                        type="text" 
                                                        name="email" 
                                                        value={this.state.email} 
                                                        onChange={e => this.handleChange(e, 'email')} 
                                                        placeholder="Email"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Telefone</Form.Label>
                                                    <Form.Control
                                                        as={IMaskInput} 
                                                        mask="(00) 00000-0000"
                                                        name="telefone"
                                                        value={this.state.telefone}
                                                        onChange={e => this.handleChange(e, 'telefone')} 
                                                        placeholder="Telefone"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Programa <span>*</span></Form.Label>
                                                    <AsyncSelect
                                                        required
                                                        cacheOptions
                                                        loadOptions={this.carregaProgramas}
                                                        defaultOptions
                                                        name="programa_id"
                                                        placeholder={"Buscar programa..."}
                                                        noOptionsMessage={() => "Nenhum programa encontrado" }
                                                        onChange={(e) => this.handleChange(e, "programa_id")}
                                                        value={this.state.programa_id ? {value: this.state.programa_id, label: this.state.programa_nome,}: null}
                                                        styles={{
                                                            option: (provided) => ({
                                                                ...provided,
                                                                fontSize: '12px', 
                                                            }),
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Estados</Form.Label>
                                                    <AsyncSelect
                                                        isMulti
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={this.carregarEstados}
                                                        placeholder="Buscar estados..."
                                                        noOptionsMessage={() => "Nenhum estado encontrado"}
                                                        onChange={this.handleChangeEstados}
                                                        value={this.state.estados}
                                                        styles={{
                                                            option: (provided) => ({
                                                                ...provided,
                                                                fontSize: '12px',
                                                            }),
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col sm={6} xs={12}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Patologias</Form.Label>
                                                    <AsyncSelect
                                                        key={this.state.doencas_select_key}
                                                        isMulti
                                                        cacheOptions
                                                        defaultOptions
                                                        isDisabled={!this.state.programa_id}
                                                        loadOptions={this.carregarDoencas}
                                                        placeholder={this.state.programa_id ? "Buscar patologias..." : "Selecione um programa primeiro"}
                                                        noOptionsMessage={() => "Nenhuma patologia encontrada"}
                                                        onChange={this.handleChangeDoencas}
                                                        value={this.state.doencas}
                                                        styles={{
                                                            option: (provided) => ({
                                                                ...provided,
                                                                fontSize: '12px',
                                                            }),
                                                        }}
                                                    />
                                                    <Form.Text className="text-muted">
                                                        O consultor será sugerido no atendimento pela combinação de patologia e UF do CRM do médico.
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={4}>
                                                <Button variant="success" className="btn-sm" onClick={this.enviaRegistro}>
                                                    <FaCheck className="me-1" /> Salvar Consultor
                                                </Button>&nbsp;&nbsp;
                                            </Col>
                                        </Row>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ConsultoresEdit);